export default "__VITE_ASSET__C7mJfaD___"